import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { KybConfigCard } from "@/modules/admin";

export default function AdminKybPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.kyb.pageTitle")}
      description={t("admin.kyb.pageDescription")}
    >
      <PermissionGate
        perm="org.read"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <KybConfigCard />
      </PermissionGate>
    </AppLayout>
  );
}
